import { Delete, Edit, Send, VisibilityOff } from "@mui/icons-material";
import useAuth from "app/hooks/useAuth";
import { useMemo } from "react";
export const useGetTableActions = (handleOpenDialog) => {
  const { user } = useAuth();
  return useMemo(() => {
    if (user.role === "SA") {
      return [
        {
          icon: <Edit style={{ color: "#01579b" }} />,
          action: handleOpenDialog,
          id: "editOpen",
          style: { height: "45px", "&:hover": { background: "#cccccc" } }
        },
        {
          icon: <Delete style={{ color: "#ff1744" }} />,
          action: handleOpenDialog,
          id: "deleteOpen",
          style: { height: "45px", "&:hover": { background: "#cccccc" } }
        },
        {
          icon: <VisibilityOff style={{ color: "#43a047" }} />,
          action: handleOpenDialog,
          id: "statusOpen",
          style: { height: "40px", width: "40px", "&:hover": { background: "#cccccc" } }
        }
      ];
    }

    if (user.role === "company") {
      return [
        {
          icon: <Edit style={{ color: "#01579b" }} />,
          action: handleOpenDialog,
          id: "editOpen",
          style: { height: "45px", "&:hover": { background: "#cccccc" } }
        },
        {
          icon: <Delete style={{ color: "#ff1744" }} />,
          action: handleOpenDialog,
          id: "deleteOpen",
          style: { height: "45px", "&:hover": { background: "#cccccc" } }
        },
        {
          icon: <VisibilityOff style={{ color: "#43a047" }} />,
          action: handleOpenDialog,
          id: "statusOpen",
          style: { height: "40px", width: "40px", "&:hover": { background: "#cccccc" } }
        }
      ];
    }

    if (user.role === "candidate") {
      return [
        {
          icon: <Send />,
          action: handleOpenDialog,
          text: "Apply",
          id: "applyOpen",
          variant: "contained",
          style: { "&:hover": { background: "#555a6f" } }
        }
      ];
    }
  }, [user.role, handleOpenDialog]);
};
